<template>
  <div class="history-introduction">
    <h1 class="section-title">书法历史介绍</h1>
    
    <div class="history-timeline">
      <!-- 先秦时期 -->
      <div class="timeline-item">
        <div class="timeline-period">先秦时期</div>
        <div class="timeline-content">
          <h3>甲骨文与金文</h3>
          <p>甲骨文是中国最早的成熟文字系统，主要刻在龟甲和兽骨上，用于占卜记录。金文则是铸刻在青铜器上的文字，字体端庄古朴，线条浑厚有力。</p>
          <p>这一时期的书法尚未形成独立的艺术形式，但为后世书法的发展奠定了基础。</p>
        </div>
      </div>
      
      <!-- 秦汉时期 -->
      <div class="timeline-item">
        <div class="timeline-period">秦汉时期</div>
        <div class="timeline-content">
          <h3>篆书与隶书</h3>
          <p>秦代统一文字，推行小篆，字体规整统一。汉代隶书兴起，笔画简化，书写便捷，成为官方文书的标准字体。</p>
          <p>隶书的出现是中国书法史上的重要转折点，为后来的草书、楷书、行书奠定了基础。</p>
        </div>
      </div>
      
      <!-- 魏晋南北朝 -->
      <div class="timeline-item">
        <div class="timeline-period">魏晋南北朝</div>
        <div class="timeline-content">
          <h3>楷书的成熟</h3>
          <p>魏晋时期，楷书逐渐成熟，成为主要的书体。王羲之、王献之父子的书法成就最高，被后世尊为"书圣"。</p>
          <p>这一时期书法理论也得到了发展，出现了《笔论》《书谱》等重要著作。</p>
        </div>
      </div>
      
      <!-- 隋唐五代 -->
      <div class="timeline-item">
        <div class="timeline-period">隋唐五代</div>
        <div class="timeline-content">
          <h3>书法的鼎盛</h3>
          <p>唐代是中国书法的鼎盛时期，楷书、行书、草书都达到了很高的水平。颜真卿、柳公权、欧阳询等书法家的作品成为后世学习的典范。</p>
          <p>唐代书法注重法度，风格严谨端庄，对后世影响深远。</p>
        </div>
      </div>
      
      <!-- 宋元明清 -->
      <div class="timeline-item">
        <div class="timeline-period">宋元明清</div>
        <div class="timeline-content">
          <h3>书法的多元化</h3>
          <p>宋代书法注重意趣，强调个人风格。苏轼、黄庭坚、米芾、蔡襄被称为"宋四家"。元代赵孟頫提倡复古，明代书法流派众多，清代碑学兴起。</p>
          <p>这一时期书法理论更加完善，出现了许多书法论著和丛帖。</p>
        </div>
      </div>
      
      <!-- 近现代 -->
      <div class="timeline-item">
        <div class="timeline-period">近现代</div>
        <div class="timeline-content">
          <h3>书法的传承与创新</h3>
          <p>近现代书法在继承传统的基础上，不断创新发展。于右任、沈尹默、林散之等书法家为书法的传承和发展做出了重要贡献。</p>
          <p>当代书法更加多元化，书法教育也得到了普及，为书法的未来发展注入了新的活力。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryIntroduction'
}
</script>

<style scoped>
.history-introduction {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.section-title {
  font-size: 2.5em;
  color: #333;
  text-align: center;
  margin-bottom: 60px;
  font-family: 'SimSun', serif;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 100px;
  height: 3px;
  background: #999;
  margin: 20px auto;
}

.history-timeline {
  position: relative;
}

.history-timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #ddd;
  transform: translateX(-50%);
}

.timeline-item {
  position: relative;
  margin-bottom: 60px;
  display: flex;
  align-items: center;
}

.timeline-item:nth-child(odd) {
  flex-direction: row-reverse;
}

.timeline-period {
  width: 200px;
  text-align: center;
  font-size: 1.2em;
  font-weight: bold;
  color: #666;
  font-family: 'SimSun', serif;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 4px;
  position: relative;
  z-index: 1;
}

.timeline-content {
  flex: 1;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin: 0 40px;
  position: relative;
}

.timeline-content::before {
  content: '';
  position: absolute;
  top: 50%;
  width: 20px;
  height: 20px;
  background: #fff;
  border: 2px solid #999;
  border-radius: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.timeline-item:nth-child(odd) .timeline-content::before {
  left: -10px;
}

.timeline-item:nth-child(even) .timeline-content::before {
  right: -10px;
}

.timeline-content h3 {
  font-size: 1.4em;
  color: #333;
  margin-bottom: 15px;
  font-family: 'SimSun', serif;
}

.timeline-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .history-timeline::before {
    left: 30px;
  }
  
  .timeline-item {
    flex-direction: row !important;
    align-items: flex-start;
  }
  
  .timeline-period {
    width: 120px;
    text-align: left;
    padding-left: 20px;
  }
  
  .timeline-content {
    margin-left: 60px;
    margin-right: 20px;
  }
  
  .timeline-content::before {
    left: -10px !important;
    right: auto !important;
  }
}
</style>